<script setup lang="ts">
import { onMounted, ref } from 'vue'

import UiButton from '@/components/UiButton.vue'
import { loginStartUrl } from '@/lib/loginFragment'

const logoSrc = import.meta.env.BASE_URL + 'assets/logo-tight.png'
const error = ref<string | null>(null)

onMounted(() => {
  const le = new URLSearchParams(location.search).get('login_error')
  if (le) {
    error.value = le
    history.replaceState(null, '', location.pathname)
  }
})

function googleLogin() {
  // 批185（FE-07）：帶一次性 nonce 出發，回來時 `boot.ts` 只收 nonce 對得上的 token。
  window.location.href = loginStartUrl('/api/admin/auth/google/start')
}
</script>

<template>
  <div class="shell">
    <div class="card">
      <img :src="logoSrc" alt="iPlusOne" class="logo" />
      <h1>License Server 後台</h1>
      <p class="sub">愛+1 內部管理</p>
      <UiButton variant="primary" block @click="googleLogin">使用 Google 登入</UiButton>
      <p v-if="error" class="err">{{ error }}</p>
    </div>
  </div>
</template>

<style scoped>
.shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: var(--bg);
  padding: var(--sp-6);
}
.card {
  width: min(400px, 100%);
  background: var(--bg-panel);
  border: 1px solid var(--border);
  border-radius: var(--r-xl);
  box-shadow: var(--shadow-md);
  padding: var(--sp-8);
  display: grid;
  gap: var(--sp-3);
  text-align: center;
}
.logo {
  height: 48px;
  width: auto;
  object-fit: contain;
  margin: 0 auto var(--sp-2);
}
h1 {
  margin: 0;
  font-size: var(--fs-20);
  color: var(--brand-700);
}
.sub {
  margin: 0 0 var(--sp-3);
  color: var(--fg-3);
  font-size: var(--fs-12);
}
.err {
  margin: 0;
  color: var(--danger);
  font-size: var(--fs-12);
}
</style>
